// ThemeToggle — sun/moon button that flips light↔dark.
// Minimal placement in AdminHeader for now; the full Topper is Phase 2B.
import React, { useState } from 'react';
import { Sun, Moon } from 'lucide-react';
import { getTheme, toggleTheme, type Theme } from '@/lib/theme';

const btn: React.CSSProperties = {
  width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center',
  justifyContent: 'center', color: 'var(--text-secondary)', cursor: 'pointer',
  background: 'transparent', border: 'none',
};

export function ThemeToggle() {
  const [theme, setThemeState] = useState<Theme>(() => getTheme());
  const isDark = theme === 'dark';

  const onClick = () => setThemeState(toggleTheme());

  return (
    <button
      style={btn}
      onClick={onClick}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <Sun size={17} /> : <Moon size={16} />}
    </button>
  );
}
